
export default class Slide {
	constructor(slide, mod,pair) {
		this.element = slide;
		this.pair = pair;
		this.mod = mod;
	}
	
	show(dir){
		this.element.classList.add('active');
		this.element.classList.remove('d-none');
		this.button.classList.add('active-button');
	}

	bindButton(){
		let button ;
		let list = document.querySelector('[data-button-list]');	
		let buttons = list.querySelectorAll('[data-pair]');
	
		[...buttons].forEach(element => { 
		
			if(element.getAttribute('data-pair') == this.pair){
				button = element;	
			}
		});
		this.button =button;
	}
	
	hide(dir){
		this.element.classList.add('d-none');
		this.element.classList.remove('active');
		this.button.classList.remove('active-button');
	}
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/Slide.js